import {http} from "@/misc/http";

const config = {
  devMode: null,
  chatServer: null,
  keycloak: null,

  async init() {
    const config = await http.get('/app-config');
    this.devMode = config.devMode;
    this.chatServer = config.chatServerConfig;
    this.keycloak = config.keycloakConfig;
  },

}

export {
  config,
}